var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRespondUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-284.000000, -38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EE1D24",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 18.000000)",
    fill: "#FAFAFA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01280279,0 C1.91763122,0.00145844255 1.82743785,0.0391000712 1.76067375,0.106573111 L0.10653484,1.76070804 C-0.0355116134,1.90275415 -0.0355116134,2.13287339 0.10653484,2.27491041 L5.8323933,7.99857326 L0.10653484,13.7244179 L0.10653484,13.7251281 C-0.0355116134,13.8671742 -0.0355116134,14.0972935 0.10653484,14.2393305 L1.76067375,15.8934654 C1.9027202,16.0355115 2.13284,16.0355115 2.27487737,15.8934654 L7.99855399,10.1676207 L13.7244124,15.8934654 L13.7251226,15.8934654 C13.8671691,16.0355115 14.0972889,16.0355115 14.2393263,15.8934654 L15.8934652,14.2393305 C16.0355116,14.0972844 16.0355116,13.8671651 15.8934652,13.7251281 L10.1676067,7.99928344 L15.8934652,2.2756206 L15.8934652,2.27491041 C16.0355116,2.1328643 16.0355116,1.90274506 15.8934652,1.76070804 L14.2393263,0.106573111 C14.0972798,-0.035473001 13.86716,-0.035473001 13.7251226,0.106573111 L7.99926418,5.83241778 L2.27558755,0.106573111 L2.27487737,0.106573111 C2.20527506,0.0369709705 2.11081439,-0.00138193422 2.01280279,0 Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespondUnavailable);
export default __webpack_public_path__ + "static/media/respond_unavailable.ce538873.svg";
export { ForwardRef as ReactComponent };